/* Zerone: cap long Judge.me reviews at about 10 lines with a "Read more" toggle. Reviews load dynamically, so watch the DOM. */
(function () {
  function enhance(root) {
    (root || document).querySelectorAll('.jdgm-review-content__body-content:not([data-z-clamp])').forEach(function (body) {
      body.setAttribute('data-z-clamp', '1');
      body.classList.add('z-review-clamp');
      requestAnimationFrame(function () {
        if (body.scrollHeight <= body.clientHeight + 2) { body.classList.add('z-review-clamp--fits'); return; }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'z-review-more';
        btn.textContent = 'Read more';
        btn.addEventListener('click', function () {
          var open = body.classList.toggle('z-review-clamp--open');
          btn.textContent = open ? 'Show less' : 'Read more';
        });
        body.insertAdjacentElement('afterend', btn);
      });
    });
  }
  var mo = new MutationObserver(function () { enhance(); });
  function start() { enhance(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Zerone: the homepage Judge.me cards carousel has its arrows hidden on desktop, so let trackpad swipes,
   horizontal wheel and mouse drags move it by triggering the (hidden) arrow buttons. Touch swipe is Judge.me's own. */
(function () {
  function bind(car) {
    if (car.getAttribute('data-z-swipe')) return;
    var arrows = car.querySelectorAll('.jdgm-arrow');
    if (arrows.length < 2) return;
    car.setAttribute('data-z-swipe', '1');
    var prev = arrows[0], next = arrows[arrows.length - 1], last = 0;
    function go(dir) {
      var now = Date.now(); if (now - last < 650) return; last = now;
      (dir > 0 ? next : prev).click();
    }
    car.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 25) { e.preventDefault(); go(e.deltaX > 0 ? 1 : -1); }
    }, { passive: false });
    var startX = null, moved = false;
    car.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; startX = e.clientX; moved = false; }, true);
    window.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX; startX = null;
      if (Math.abs(dx) > 40) { moved = true; go(dx < 0 ? 1 : -1); }
    });
    car.addEventListener('click', function (e) { if (moved && !(e.target.closest && e.target.closest('.jdgm-arrow'))) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    car.addEventListener('dragstart', function (e) { e.preventDefault(); });
    car.style.cursor = 'grab';
  }
  function scan() { document.querySelectorAll('.jdgm-widget.jdgm-cards-carousel').forEach(bind); }
  var mo = new MutationObserver(scan);
  function start() { scan(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Zerone: product page videos play on their own (muted, looping, inline) while they're on screen,
   and pause when scrolled/swiped away. Shoppers can still tap to unmute via the player controls. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  function prep(dm) {
    if (dm.dataset.zauto) return; dm.dataset.zauto = '1';
    const tpl = dm.querySelector('template'); if (!tpl) return;
    const vidTpl = tpl.content.querySelector('video'); if (!vidTpl) return; // only native Shopify videos
    // iOS Safari only autoplays if muted + playsinline are already on the element when it's inserted
    ['muted', 'playsinline', 'loop'].forEach((a) => vidTpl.setAttribute(a, ''));
    vidTpl.removeAttribute('autoplay'); vidTpl.removeAttribute('controls');
    if (!dm.getAttribute('loaded')) { if (typeof dm.loadContent === 'function') dm.loadContent(false); }
    const v = dm.querySelector('video'); if (!v) return;
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.autoplay = false; v.removeAttribute('autoplay');
    v.controls = false;
    v.addEventListener('click', () => { v.controls = true; v.muted = false; });
    io.observe(v);
  }
  const io = new IntersectionObserver((es) => es.forEach((e) => { const v = e.target; if (e.isIntersecting && e.intersectionRatio > 0.25) { v.muted = true; const pr = v.play(); if (pr) pr.catch(() => { v.muted = true; v.play().catch(() => {}); }); } else { v.pause(); } }), { threshold: [0, 0.25, 0.5, 1] });
  function scan() { document.querySelectorAll('.product__media-list .media-type-video deferred-media, .product__media-list deferred-media.deferred-media').forEach(prep); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
